<script>

export default {
    name: 'PriceHistoryChart',
    props: {
        data: {
            type: Array,
            required: true,
        },
        min: {
            type: Number,
            default: 20,
        },
        labelInterval: {
            type: Number,
            default: 1,
        },
        regularValue: {
            type: Number,
        },
        hideRegular: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showScrollbars: false,
            resizeObserver: null,
        }
    },
    computed: {
        minValue() {
            return this.data.reduce((previousValue, currentValue) => previousValue < currentValue.price ? previousValue : currentValue.price, Infinity)
        },
        maxValue() {
            return this.data.reduce((previousValue, currentValue) => previousValue > currentValue.price ? previousValue : currentValue.price, -Infinity)
        },
        scaleMin() {
            return this.minValue < this.min
                ? Math.floor(this.minValue / this.yAxisInterval) * this.yAxisInterval
                : this.min
        },
        scaleMax() {
            return this.regularValue && this.regularValue > this.maxValue
                ? Math.ceil(this.regularValue / this.yAxisInterval) * this.yAxisInterval
                : Math.ceil(this.maxValue / this.yAxisInterval) * this.yAxisInterval
        },
        yAxisInterval() {
            return (this.maxValue - this.min) / 5 > 10
                ? 10
                : 5;
        },
        yAxis() {
            const result = [];
            for (let i = this.scaleMin; i <= this.scaleMax; i += this.yAxisInterval) {
                result.push(i)
            }
            return result.reverse();
        },
        values() {
            let prevValue = null;
            return this.data.map(value => {
                const percent = (value.price - this.scaleMin) / (this.scaleMax - this.scaleMin) * 100;
                const leftBorderHeight = prevValue !== null && prevValue.percent < percent
                    ? (percent - prevValue.percent)/100 * 260
                    : 0;
                return prevValue = {
                    ...value,
                    saving: this.regularValue - value.price,
                    percent,
                    leftBorderHeight,
                }
            })
        },
        regularPercent() {
            return (this.regularValue - this.scaleMin) / (this.scaleMax - this.scaleMin) * 100;
        }
    },
    methods: {
        formatNumber(number, maxDigits, minDigits) {
            if (typeof maxDigits === 'undefined') maxDigits = 1
            if (typeof minDigits === 'undefined') minDigits = 1
            return new Intl.NumberFormat('de-DE', {minimumFractionDigits: minDigits, maximumFractionDigits: maxDigits}).format(number)
        },
        updateScrollbars() {
            const graphWidth = this.values.length * 54 + 48;
            this.showScrollbars = this.$el.clientWidth <= graphWidth;
        },
    },
    watch: {
        values: function() {
            this.updateScrollbars()
        },
    },
    mounted() {
        this.updateScrollbars();
        this.resizeObserver = new ResizeObserver(() => {
            this.updateScrollbars();
        });
        this.resizeObserver.observe(this.$el);
    },
    beforeDestroy() {
        this.resizeObserver.disconnect();
    },
}
</script>
<template>
    <div class="barchart">
        <div class="barchart-frame" :style="{overflowX: showScrollbars ? 'scroll' : 'hidden'}">
            <div class="yaxis">
                <div v-for="(v, i) in yAxis" :key="i">{{ v }}</div>
            </div>
            <div class="bar" v-for="(v, i) in values" :key="i">
                <div class="bar-outer">
                    <div class="bar-inner" :style="{flex: `0 0 ${v.percent}%`, 'z-index': 0}">
                        <div class="leftline" :style="{height: `${v.leftBorderHeight}px`}"></div>
                        <div class="bar-label" :class="{toohigh: v.saving <= 0}">
                            <span class="saving">{{ formatNumber(v.saving) }}</span>
                            <span class="price">{{ formatNumber(v.price) }}</span>
                            ct/kWh
                        </div>
                    </div>
                </div>
                <div class="bar-time">{{ i % labelInterval === 0 ? v.label : '' }}</div>
            </div>
        </div>
        <div class="regular bar" v-if="regularValue && !hideRegular">
            <div class="bar-outer">
                <div class="bar-inner" :style="{flex: `0 0 ${regularPercent}%`}">
                    <div class="bar-label">
                        <span>{{ formatNumber(regularValue, 1, 0) }}</span>
                        ct/kWh
                    </div>
                </div>
            </div>
            <div class="bar-time"></div>
        </div>
    </div>
</template>
